import {userService} from '@/services';
import { startCrataWidget } from '@/plugins/CrataWidget';

export const userModule = {
  namespaced: true,
  state: () => ({
    entity: {
      data: null,
      status: null,
    },
    editPass: {
      data: null,
      status: null
    },
    userLists:{
      data: null,
      status: null
    },
    listFilters: {},
    newUser:{
      data: [],
      status: {},
    },
    userStatus:{
      data: null,
      status: null
    },
    deleteUser:{
      data: null,
      status: null
    },
  }),
  mutations: {
    newUser(state, req) {
      userService.newUser(req.tipo, req.id, req.user)
      .then((res) => {
        state.newUser.data = res;
        state.newUser.status = {
          created: true,
        };
      })
      .catch((error) => {
        state.newUser.data = null;
        state.newUser.status = {
          error,
        };
      });
    },
    login(state, req) {
      userService.login(req.user, req.password)
        .then((res) => {
          state.entity.data = res;
          state.entity.status = {
          logged: true
      };
          startCrataWidget();
        })
        .catch((error) => {
          state.entity.data = null;
          state.entity.status = {
            error
          };
        });
    },
    changePassword(state, body) {
      userService.changePassword(body)
        .then((res) => {
          state.editPass.data = res;
          state.editPass.status = {
        edited: true
      };
        })
        .catch((error) => {
          state.editPass.data = null;
          state.editPass.status = {error};
        });
    },
    getUsers(state, req) {
      state.listFilters = { ...JSON.parse(JSON.stringify(req)) }
      userService.getUsers(req.filters, req.pagination)
        .then((res) => {
          state.userLists.data = res;
          state.userLists.status = {
        edited: true
      };
        })
        .catch((error) => {
          state.userLists.data = null;
          state.userLists.status = {error};
        });
    },
    userStatus(state, payload){
      userService.userStatus({ status: payload.status }, payload.entityId)
      .then((res) => {
        state.userStatus.data = { ...res }
        state.userStatus.status = {
          userStatus: true
        }
      })
      .catch((error) => {
        state.userStatus.data = null
        state.userStatus.status = {
          ...error
        }
      }); 
    },
    deleteUser(state, entityId){
      userService.deleteUser(entityId._id)
      .then((res) => {
        state.deleteUser.data = { ...res }
        state.deleteUser.status = {
          deleted: true,
        }
      })
      .catch((error) => {
        state.deleteUser.data = null
        state.deleteUser.status = {
          ...error
        }
      }); 
    },
  },
}